import { Flex, Box, Heading } from '@chakra-ui/react'
import numeral from 'numeral'
import { gql } from '@apollo/client'

export const QUERY = gql`
  query {
    activePages {
      type
      count
    }
  }
`

export const Loading = () => <div>Loading...</div>

export const Empty = () => <div>Empty</div>

export const Failure = ({ error }) => <div>Error: {error.message}</div>

export const Success = ({ activePages }) => {
  return (
    <Flex paddingX={2} justifyContent="center">
      <Heading size="lg" fontWeight={300} marginBottom={10}>
        Visits per page last 30 days
      </Heading>
      <Box marginTop={10} paddingTop={10}>
        <table className="pure-table" style={{ width: '500px' }}>
          <thead>
            <tr>
              <th>Page</th>
              <th>Count</th>
            </tr>
          </thead>
          <tbody>
            {activePages.map((p, idx) => (
              <tr key={idx} className={idx % 2 === 1 ? 'pure-table-odd' : ''}>
                <td>{pageTitles[p.type] || p.type}</td>
                <td>{numeral(p.count).format()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </Flex>
  )
}

const pageTitles = {
  Home: 'School home',
  Page: 'Classroom home',
  'person/link': 'Person import link',
  'person/upsert_update': 'Update person in import',
  'person/edit': 'Edit page for person in people',
  'person/update': 'Update person in people',
  'person/myinfo_edit': 'Edit page for myinfo',
  'person/myinfo_update': 'Update person in myinfo',
  'person/upsert_create': 'Create person in import',
  'person/email_password': 'Person email/password updated',
  'person/show': 'Person 360 view',
  'person/new': 'New person in people',
  'person/create': 'Created new person in people',
  'person/destroy': 'Deleted person in people',
  'person/contribution': 'Contribution updated for person in people',
  Search: 'Search People',
  Announcements: 'Announcements in administration',
}
